import { cssVar } from '@chakra-ui/react';

const $fg = cssVar('tag-color');

const baseStyleContainer = {
  fontWeight: 'semibold',
  lineHeight: 1.2,
  outline: 0,
  borderRadius: 'md',
};

const baseStyleLabel = {
  lineHeight: 1.2,
  overflow: 'visible',
};

const baseStyleCloseButton = {
  fontSize: 'lg',
  w: '5',
  h: '5',
  transitionProperty: 'common',
  transitionDuration: 'normal',
  borderRadius: 'full',
  marginStart: '1.5',
  marginEnd: '-1',
  opacity: 0.5,
  _disabled: {
    opacity: 0.4,
  },
  _focusVisible: {
    boxShadow: 'outline',
    bg: 'rgba(0, 0, 0, 0.14)',
  },
  _hover: {
    opacity: 0.8,
  },
  _groupHover: {
    opacity: 0.65,
    _hover: {
      opacity: 0.9,
    },
  },
  _active: {
    opacity: 1,
  },
};

const baseStyle = {
  container: baseStyleContainer,
  label: baseStyleLabel,
  closeButton: baseStyleCloseButton,
};

const sizes = {
  sm: {
    container: {
      minH: '5',
      minW: '5',
      fontSize: 'xs',
      px: '2',
    },
    closeButton: {
      marginEnd: '-2px',
      marginStart: '0.35rem',
    },
  },
  md: {
    container: {
      minH: '26px',
      minW: '6',
      fontSize: 'sm',
      px: '2',
    },
  },
  lg: {
    container: {
      minH: '8',
      minW: '8',
      fontSize: 'md',
      px: '3',
    },
  },
};

const variants = {
  subtle: {
    container: {
      ...baseStyle.container,
      color: 'text.secondary',
      bgColor: 'background.secondary',
    },
    closeButton: {
      ...baseStyle.closeButton,
      color: 'blackAlpha.400',
    },
  },
  solid: {
    container: {
      ...baseStyle.container,
      bgColor: 'blackAlpha.500',
    },
  },
  outline: {
    container: {
      ...baseStyle.container,
      color: 'text.secondary',
      [$fg.variable]: 'colors.stroke.grey',
      boxShadow: `inset 0 0 0px 1px ${$fg.reference}`,
    },
    closeButton: {
      ...baseStyle.closeButton,
      color: 'blackAlpha.500',
    },
  },
};

export const Tag = {
  variants,
  baseStyle,
  sizes,
  defaultProps: {
    size: 'md',
    variant: 'subtle',
    colorScheme: 'gray',
  },
};
